// extracted by mini-css-extract-plugin
export default {"container_info":"style_container_info__2XPXI"};